import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BellIcon, CheckIcon } from 'lucide-react';
export function DealAlerts() {
  const [email, setEmail] = useState('');
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dealTypes = ['Cash-Flowing Properties', 'Equity Plays / Fixer-Uppers', 'Vacant Land', 'Commercial Opportunities', 'Pre-Construction Deals'];
  const handleTypeToggle = (type: string) => {
    setSelectedTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && selectedTypes.length > 0) {
      console.log('Alert subscription:', {
        email,
        selectedTypes
      });
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail('');
        setSelectedTypes([]);
      }, 3000);
    }
  };
  return <section className="py-24 bg-navy" data-id="element-108" data-mp="1o85o5te6b08o">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109" data-mp="1o74bjkhie5ou">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-110" data-mp="1jbfafcpucgqf">
          <BellIcon className="text-gold mx-auto mb-4" size={48} data-id="element-111" data-mp="10jmg9ez1cph4" />
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-white mb-6" data-id="element-112" data-mp="10ibdnihbtnrl">
            Join the Alert List
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-113" data-mp="qlghh68izzgh">
            Tell us what you're looking for. When a deal that matches hits our
            radar, we'll reach out — only then.
          </p>
          <p className="text-white/60 mt-4" data-id="element-114" data-mp="hl0eryzlwwco">
            Email only. No spam. No sales calls.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-charcoal rounded-lg p-8 sm:p-10 border border-white/10" data-id="element-115" data-mp="6ylmte8sphn9">
          {isSubmitted ? <div className="text-center py-8" data-id="element-116" data-mp="qpqlw245zmnc">
              <CheckIcon className="text-gold mx-auto mb-4" size={64} data-id="element-117" data-mp="uphbw3lv9yqt" />
              <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-118" data-mp="gxug04vu6s8k">
                You're on the list!
              </h3>
              <p className="text-white/80" data-id="element-119" data-mp="lvvusdm8c5e8">
                We'll notify you when deals matching your criteria become
                available.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-120" data-mp="1edgozl3wlhze">
              <div data-id="element-121" data-mp="1ns0hxf3mriu0">
                <label className="block text-white font-semibold mb-3" data-id="element-122" data-mp="1nribxqr61q8w">
                  What type of deals interest you? (Select all that apply)
                </label>
                <div className="space-y-3" data-id="element-123" data-mp="1jolzkhs7yqde">
                  {dealTypes.map(type => <label key={type} className="flex items-center text-white/80 hover:text-white cursor-pointer group" data-id="element-124" data-mp="1xjo5v60zahqq">
                      <div className="relative" data-id="element-125" data-mp="14v8s0mtl25gz">
                        <input type="checkbox" checked={selectedTypes.includes(type)} onChange={() => handleTypeToggle(type)} className="sr-only" data-id="element-126" data-mp="10scg1eyjt7m0" />
                        <div className={`w-5 h-5 border-2 rounded transition-all ${selectedTypes.includes(type) ? 'bg-gold border-gold' : 'border-white/30 group-hover:border-gold/50'}`} data-id="element-127" data-mp="2q6iqc2xsph47">
                          {selectedTypes.includes(type) && <CheckIcon className="text-navy" size={16} strokeWidth={3} data-id="element-128" data-mp="zp5b465b77cl" />}
                        </div>
                      </div>
                      <span className="ml-3" data-id="element-129" data-mp="1dp6bzllkqes2">{type}</span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-130" data-mp="1in7w89uqkk54">
                <label className="block text-white font-semibold mb-3" data-id="element-131" data-mp="1imevpqmdeqvf">
                  Your Email Address
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="investor@example.com" required className="w-full bg-navy text-white border border-white/20 rounded-lg px-4 py-3 focus:outline-none focus:border-gold transition-colors" data-id="element-132" data-mp="1se2r22m1ss26" />
              </div>

              <button type="submit" disabled={selectedTypes.length === 0 || !email} className="w-full bg-gold hover:bg-gold-light text-navy px-8 py-4 rounded-lg font-bold text-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-133" data-mp="3gx6yipowdyxa">
                Subscribe to Deal Alerts
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}